module.exports = __webpack_public_path__ + "img/Metafinanz_Logo_RGB.d0d8ffd0.svg";